import { render, staticRenderFns } from "./BaseProductsPage.vue?vue&type=template&id=7b41f1a6"
import script from "./BaseProductsPage.vue?vue&type=script&lang=js"
export * from "./BaseProductsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports